import * as React from 'react'
import { ActivitiesContext } from './context'
import type { ReactElement } from 'react'
import type { ActivityDetails } from '../typings'
import { useData } from './hooks'

type Props = {
  children: ReactElement
  // SH-1432: seed UPDATE mode (edit an existing activity). Omitted => create mode.
  initialCurrent?: number
  initialActivities?: ActivityDetails[]
}

export function ActivitiesContextProvider(props: Props) {
  const { children, initialCurrent, initialActivities } = props
  const { value } = useData({ initialCurrent, initialActivities })

  return (
    <ActivitiesContext.Provider value={value}>
      {children}
    </ActivitiesContext.Provider>
  )
}
